import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

export type IconCaretButtonLeftProps = {
  theme?: IconTheme;
  style?: "filled" | "outline";
  className?: string;
  title?: string;
};

interface IconCaretButtonLeftSvgProps {
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

function DefaultSvg({ className, title }: IconCaretButtonLeftSvgProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <polygon points="14.07 18.76 7.31 12.01 14.07 5.26 15.81 7 10.78 12.01 15.81 17.03 14.07 18.76"></polygon>
    </svg>
  );
}

function OutlineSvg({ className, title }: IconCaretButtonLeftSvgProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? "img" : "presentation"}
      aria-label={title}
      className={className}
    >
      <path d="M8.98002 11.0267L5.96002 8.00669L8.98002 4.98669L9.68669 5.69336L7.37336 8.00669L9.68669 10.3134L8.98002 11.0267Z" />
    </svg>
  );
}

export default function IconCaretButtonLeft({
  theme = "black",
  style = "filled",
  className,
  title,
}: IconCaretButtonLeftProps) {
  const themeClassname = THEME_COLOR[theme];
  const Variant = style === "outline" ? OutlineSvg : DefaultSvg;

  return <Variant title={title} className={cn(className, themeClassname)} />;
}
